import type { TrackFunction } from "@similarweb/contact-us";

import createTrackingEventName from "app/pages/sales-intelligence/utils/testing/createTrackingEventName";

enum OnboardingHubAction {
    Hover = "hover",
    Click = "click",
    Status = "status",
    Expand = "expand",
    Collapse = "collapse",
}

const ONBOARDING_HUB_BUTTON = "onboarding hub button";

export default function createOnboardingHubTrackingService(track: TrackFunction) {
    function trackOnboardingHubEvent(
        action: OnboardingHubAction,
        eventName: string,
        eventSubName?: string | number,
        eventSubSubName?: string | number,
    ): void {
        const event: string = createTrackingEventName(eventName, eventSubName, eventSubSubName);

        track("onboarding hub", action, event);
    }

    return {
        trackHoverOverHubButton(completedItemsCount: number, totalItemsCount: number) {
            trackOnboardingHubEvent(
                OnboardingHubAction.Hover,
                ONBOARDING_HUB_BUTTON,
                `${completedItemsCount}-${totalItemsCount}`,
            );
        },
        trackClickHubButton(completedItemsCount: number, totalItemsCount: number) {
            trackOnboardingHubEvent(
                OnboardingHubAction.Click,
                ONBOARDING_HUB_BUTTON,
                `${completedItemsCount}-${totalItemsCount}`,
            );
        },

        trackOpenHubWindow(completedItemsCount: number, totalItemsCount: number) {
            trackOnboardingHubEvent(
                OnboardingHubAction.Status,
                "onboarding hub status",
                `${completedItemsCount}-${totalItemsCount}`,
            );
        },
        trackClickOnTask(taskTitle: string, taskNumber?: number, subSubName?: string) {
            trackOnboardingHubEvent(OnboardingHubAction.Click, taskTitle, taskNumber, subSubName);
        },
        trackExpandCollapseTask(isExpand: boolean, taskTitle: string, navigation?: string) {
            trackOnboardingHubEvent(
                isExpand ? OnboardingHubAction.Expand : OnboardingHubAction.Collapse,
                isExpand ? "expand task" : "collapse task",
                taskTitle,
                navigation,
            );
        },
    };
}
